import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/esnext.json.parse.js";
import "core-js/modules/esnext.uint8-array.set-from-base64.js";
import "core-js/modules/esnext.uint8-array.set-from-hex.js";
import "core-js/modules/esnext.uint8-array.to-base64.js";
import "core-js/modules/esnext.uint8-array.to-hex.js";
import "core-js/modules/web.dom-exception.stack.js";
import axios from 'axios';
import html2canvas from 'html2canvas';
import QRCode from 'qrcodejs2';
export default {
  props: [],
  data() {
    return {
      pageWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
      pageHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
      list: [],
      miniCodeUrl: "",
      loading: null
    };
  },
  components: {},
  methods: {
    /**
     * 二进制容器
     * @param {String} dataurl
     */
    getUint8Arr(dataurl) {
      // 截取base64的数据内容
      let arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        // 获取解码后的二进制数据的长度，用于后面创建二进制数据容器
        n = bstr.length,
        // 创建一个Uint8Array类型的数组以存放二进制数据
        u8arr = new Uint8Array(n);
      // 将二进制数据存入Uint8Array类型的数组中
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return {
        u8arr,
        mime
      };
    },
    /**
     * canvas转dataURL
     * @param {canvas} canvas
     */
    convertCanvasToImage(canvas) {
      // let image = new Image()
      // image.src = canvas.toDataURL('image/png')
      return canvas.toDataURL('image/png');
    },
    /**
     * dataURL转Blob对象
     * @param {String} dataurl
     */
    dataURLtoBlob(dataurl) {
      let uint8 = this.getUint8Arr(dataurl);
      return new Blob([uint8.u8arr], {
        type: uint8.mime
      });
    },
    /**
     * Blob转换为File
     * @param {Blob} theBlob
     * @param {String} fileName
     */
    blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date();
      theBlob.name = fileName;
      return theBlob;
    },
    generateFilePoster(domId) {
      return new Promise((resolve, reject) => {
        html2canvas(document.getElementById(domId), {
          useCORS: true
        }).then(canvas => {
          // document.body.appendChild(canvas);
          let dataUrl = this.convertCanvasToImage(canvas);
          let blob = this.dataURLtoBlob(dataUrl);
          // let file=this.blobToFile(blob,domId);
          resolve(blob);
        });
      });
    },
    backClick() {
      this.$router.back(-1);
    },
    // 图片元素转base64
    getBase64Image(img) {
      let canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      let ctx = canvas.getContext('2d');
      ctx === null || ctx === void 0 || ctx.drawImage(img, 0, 0, img.width, img.height);
      let dataURL = canvas.toDataURL('image/png');
      return dataURL;
    },
    // 图片元素转base64
    getBase64(img) {
      let canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      let ctx = canvas.getContext('2d');
      ctx === null || ctx === void 0 || ctx.drawImage(img, 0, 0, img.width, img.height);
      let dataURL = canvas.toDataURL('image/png');
      return dataURL;
    },
    // base64图片转为blob
    getBlobImage(dataurl) {
      let arr = dataurl.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime
      });
    },
    // 复制图片
    copyImage(dom, callback) {
      let dataurl = this.getBase64Image(dom);
      let blob = this.getBlobImage(dataurl);
      navigator.clipboard.write([new window.ClipboardItem({
        [blob.type]: blob
      })]).then(callback, function () {
        console.log('图片复制失败！');
      });
    },
    imgClick(idx) {
      let item = this.list[idx];
      console.log("imgClick...");
      let image = document.getElementById(item.val + idx);
      this.copyImage(image, () => {
        console.log("imgClick...");
        const {
          ipcRenderer
        } = window.require('electron');
        ipcRenderer.send('type-img');
      });
      // if(this.tools.isElectron){

      // }
    },
    videoClick() {
      let videoUrl = "https://videossl.edujia.com/ime/pptzx2/phrase/1696820115853.mp4";
      axios.post(videoUrl, {}, {
        responseType: 'blob'
      }).then(function (response) {
        // this.url = window.URL.createObjectURL(new Blob([response.data]));
        console.log("file response:", response);
        let blob = new Blob([response.data], {
          type: response.data.type
        });
        navigator.clipboard.write([new window.ClipboardItem({
          [blob.type]: blob
        })]).then(function () {
          // if (typeof cb === 'function') {
          //   cb();
          // }
        }, function (error) {
          console.log('视频复制失败！ error:', error);
        });
      });
    },
    async getMiniCode(url, type) {
      return new Promise(async (resolve, reject) => {
        let params = {
          url: url,
          type: type
        };
        let resp = await this.$http.huashuGetMiniCode(params);
        if (resp.code == 200) {
          resolve(resp.data.object.image);
        }
      });
    },
    async fileClick(idx) {
      this.loading = this.$loading.service({
        lock: true,
        text: '发送中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        fullscreen: true
      });
      console.log("fileClick...");
      let posterId = 'filePoster' + this.list[idx].val;
      this.miniCodeUrl = await this.getMiniCode(this.list[idx].val, 3);
      setTimeout(async () => {
        let blob = await this.generateFilePoster(posterId);
        navigator.clipboard.write([new window.ClipboardItem({
          [blob.type]: blob
        })]).then(() => {
          this.loading.close();
          const {
            ipcRenderer
          } = window.require('electron');
          ipcRenderer.send('type-img');
        });
        // return;

        // let image=document.getElementById(posterId);
        // this.copyImage(image,()=>{
        //     console.log("imgClick...");
        //     const {ipcRenderer} = window.require('electron');
        //     ipcRenderer.send('type-img');
        // });
      }, 1);
    },
    audioClick(idx) {
      this.loading = this.$loading.service({
        lock: true,
        text: '发送中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        fullscreen: true
      });
      let itemData = this.list[idx];
      new QRCode("audioQr" + itemData.id, {
        text: this.list[idx].val,
        // 需要转换为二维码的内容
        width: 160,
        height: 160,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      });
      setTimeout(async () => {
        let blob = await this.generateFilePoster("audioPoster" + itemData.id);
        navigator.clipboard.write([new window.ClipboardItem({
          [blob.type]: blob
        })]).then(() => {
          this.loading.close();
          const {
            ipcRenderer
          } = window.require('electron');
          ipcRenderer.send('type-img');
        });
      }, 1);
    },
    fileClickBak() {
      let fileUrl = "https://video.lingtuo.cn/kiXcx/speech/text/media/3mhyjt/1691389495865_0.pdf";
      axios.post(fileUrl, {}, {
        responseType: 'blob'
      }).then(function (response) {
        // this.url = window.URL.createObjectURL(new Blob([response.data]));
        console.log("file response:", response);
        let blob = new Blob([response.data], {
          type: response.data.type
        });
        navigator.clipboard.write([new window.ClipboardItem({
          [blob.type]: blob
        })]).then(function () {
          // if (typeof cb === 'function') {
          //   cb();
          // }
        }, function () {
          console.log('文件复制失败！');
        });
      });
      // let blob = this.getBlobImage(dataurl);
      // navigator.clipboard.write([
      //   new window.ClipboardItem({
      //     [blob.type]: blob
      //   })
      // ]).then(function() {
      //   // if (typeof cb === 'function') {
      //   //   cb();
      //   // }
      // }, function() {
      //   console.log('图片复制失败！');
      // });
      // const {ipcRenderer} = window.require('electron');
      // if(ipcRenderer){
      //     ipcRenderer.send('type-img');
      // }
    },
    //查询话术可添加的文件类型
    async qryHuashuListTitle(list) {
      return new Promise(async (resolve, reject) => {
        let params = {
          urlArray: JSON.stringify(list)
        };
        let resp = await this.$http.qryHuashuListTitle(params);
        if (resp.code == 200) {
          resolve(resp.data.array);
        } else {
          resolve([]);
        }
      });
    }
  },
  async mounted() {
    console.log("created...");
    window.addEventListener('resize', () => {
      this.pageWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      this.pageHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    });
    if (localStorage.getItem("huashuData")) {
      let huashuData = JSON.parse(localStorage.getItem("huashuData"));
      let urlList = huashuData.filelist.map(file => {
        return file.val;
      });
      let mapList = [];
      if (urlList.length) {
        mapList = await this.qryHuashuListTitle(urlList);
      }
      this.list = huashuData.eleList.filter(val => {
        if (val.type == 'img' && val.val.slice(-5) == 'video' || val.type == 'file' || val.type == 'audio') {
          val.title = mapList.find(info => {
            return info.url == val.val;
          }).title;
        }
        val.val = val.val.replace("http://", "https://");
        return val.type == 'img' || val.type == 'file' || val.type == 'audio';
      });
    }
  }
};